export function getPercentageOptions(maxAvailableShare: number, currentBeneficiaryShare: number = 0) {
    const options: { value: string; label: string }[] = [];
    const includedValues = new Set<number>();

    const effectiveMax = Math.min(100, maxAvailableShare);

    for (let percentage = 10; percentage <= effectiveMax; percentage += 5) {
        if (percentage === 95) {
            continue;
        }
        options.push({ value: String(percentage), label: `${percentage}%` });
        includedValues.add(percentage);
    }

    if (
        currentBeneficiaryShare > 0 &&
        currentBeneficiaryShare <= effectiveMax &&
        !includedValues.has(currentBeneficiaryShare)
    ) {
        options.push({ value: String(currentBeneficiaryShare), label: `${currentBeneficiaryShare}%` });
        options.sort((optionA, optionB) => Number(optionA.value) - Number(optionB.value));
    }

    return options;
}
